module.exports = __webpack_public_path__ + "img/g-travel.3da7d2f2.jpg";